import styled from 'styled-components/macro';
import { VerticalCenter } from '../../../../shared-styles';
import { FlexJustifyBetween } from '../../../../shared-styles/flex';

const Container = styled.div`
  ${FlexJustifyBetween}
  height: 50px;
  box-shadow: 2px 2px 5px ${(props) => props.theme.palette.lightGray[75]};
  overflow: none;
  z-index: 1000;
  background-color: ${(props) => props.theme.palette.white};
  padding: 0 ${(props) => props.theme.spacing(30)};
`;

export const TitleContainer = styled.div`
  ${VerticalCenter};
`;

export const Title = styled.h2`
  letter-spacing: 0px;
  color: ${(props) => props.theme.palette.blue[100]};
  font-weight:  ${(props) => props.theme.typography.weight.bold};
`;

export const TabsContainer = styled.div`
  padding-top: ${(props) => props.theme.spacing(8)};
`;

export default Container;
